import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy Updated</h1>
      <p>Effective 20 March 2025.</p>
      
      <h2>IMPRESSUM</h2>
      <p>Ada Jungblut FZCO</p>
      <p>Address: Dubai Silicon Oasis</p>
      <p>Phone: +971 585 915 922</p>
      <p>Managing Director: Wassili Jungblut</p>
      <p>Responsible for Content: Wassili Jungblut</p>

      <p>At Ada Jungblut, we are committed to protecting the privacy and security of our users. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information when you use our app. By using Ada Jungblut (the "App"), you consent to the practices described in this Privacy Policy.</p>
      
      <h2>1. Information We Collect</h2>
      <p>We collect the following personal information when you register an account:</p>
      <ul>
        <li><strong>Name:</strong> Used for personalization within the app.</li>
        <li><strong>Email:</strong> Required for account creation, login, and communication.</li>
        <li><strong>Password:</strong> Used to secure your account.</li>
        <li><strong>Date of Birth (DOB):</strong> Used to generate the Chakra Calendar, a core feature of the app.</li>
      </ul>

      <h2>2. Why We Collect This Information</h2>
      <ul>
        <li><strong>Account Creation & Authentication:</strong> Name, Email, and Password are necessary to create and manage user accounts securely.</li>
        <li><strong>Chakra Calendar Functionality:</strong> Date of Birth is required to provide accurate Chakra Calendar insights.</li>
      </ul>

      <h2>3. How We Use This Information</h2>
      <ul>
        <li>We use Name, Email, and Password for authentication and user account management.</li>
        <li>We use Date of Birth exclusively for generating the Chakra Calendar and do not share it with third parties.</li>
      </ul>

      <h2>4. Account Deletion</h2>
      <p>Users have the right to delete their accounts at any time. Once a user requests account deletion, the account and associated data will be completely removed within 3 days, unless legal obligations require us to retain certain information.</p>

      <h2>5. Data Security & Protection</h2>
      <p>We store your data securely and use industry-standard encryption to protect sensitive information, including passwords. We implement security measures to prevent unauthorized access, disclosure, or alteration of your personal data.</p>

      <h2>6. Our Services</h2>
      <p>We offer a personalized Energy Mapping experience based on your birth date. This unique tool provides valuable insights into your chakra energies, helping you understand their influence on different aspects of your life.</p>

      <h2>7. Legal Compliance & Governing Law</h2>
      <p>All services and policies under Ada Jungblut FZCO comply with the laws of the United Arab Emirates (UAE). By using our platform, you agree that any legal matters related to our services will be governed by UAE laws.</p>

      <h2>8. Intellectual Property Rights</h2>
      <p>All content, including text, images, and digital assets, is the exclusive property of Ada Jungblut FZCO and is protected under copyright laws. Any reproduction, modification, or distribution of our content without prior written consent is strictly prohibited.</p>

      <h2>9. Data Protection & Your Rights</h2>
      <ul>
        <li><strong>Right to Access:</strong> You can request a copy of the personal data we have stored about you.</li>
        <li><strong>Right to Rectification:</strong> If your information is incorrect or outdated, you may request corrections.</li>
        <li><strong>Right to Erasure:</strong> You can ask us to delete your data unless legal obligations require us to retain it.</li>
        <li><strong>Right to Restrict Processing:</strong> In certain cases, you can request that we limit how your data is used.</li>
      </ul>

      <h2>10. Updates to This Policy</h2>
      <p>We may modify this Privacy Policy periodically to reflect updates in our services, security practices, or legal obligations. If any significant changes occur, we will notify you through appropriate communication channels. We encourage you to review this policy regularly to stay informed.</p>
    </div>
  );
};

export default PrivacyPolicy;